import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import parsePhoneNumber, { isValidPhoneNumber, AsYouType } from 'libphonenumber-js';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.css']
})
export class PhoneNumberInputComponent implements OnInit {
  @Input() placeholder = 'Enter phone number';
  @Input() initialCountry = 'PK'; // Default country code
  @Input() phoneNumber = ''; // Two-way bound phone number

  @Output() phoneNumberChange = new EventEmitter<string>(); // Emit phone number changes
  @Output() validNumber = new EventEmitter<string>(); // Emit formatted number for display purposes
  @Output() formattedForSaving = new EventEmitter<string>(); // Emit the formatted number for saving
  @Output() isValidNumber = new EventEmitter<boolean>(); // If length is less or high according country code emit number is invalid or proceed button in signup disabled.

  countryOptions = [
    { label: "Pak (+92)", value: 'PK' },
    { label: "Afg (+93)", value: 'AF' },
    { label: "USA (+1)", value: 'US' },
    { label: 'SA (+966)', value: 'SA' },
    { label: 'UAE (+971)', value: 'AE' },
    { label: "UK (+44)", value: 'GB' },
  ];

  selectedCountry;
  invalidNumber = false;
  // emptyNumber: boolean = true;
  invalidMessage = 'Phone number is not valid.';

  // emptyMessage: string = 'empty';
  formattedNumber: string;
  formattedNumberForDisplaying: string;
  currentUser: any;
  currentUserData: any;
  hasCountryCode = false;

  ngOnInit() {    
    setTimeout(() => {
      if(this.phoneNumber){
        const phoneNumberParsed = parsePhoneNumberFromString(this.phoneNumber);
        if (phoneNumberParsed && phoneNumberParsed.country) {
          this.selectedCountry = phoneNumberParsed.country;
        }
        else{
          this.selectedCountry = "PK";
        }
      }
      else{
        this.selectedCountry = "PK";
      }
        this.validateNumber(this.selectedCountry, this.phoneNumber);
    }, 1000);
  }

  onCountryCodeChange(event) {
    this.validateNumber(event, this.phoneNumber);
  }

  onPhoneNumberChange(event) {
    this.validateNumber(this.selectedCountry, event);
  }
  validateNumber(country, number) {
    if(isValidPhoneNumber(number, country)) {
        this.invalidNumber = false;
        const phoneNumber = parsePhoneNumber(number,country)
        if (phoneNumber) {
            if(phoneNumber.country === country){
              this.formattedForSaving.emit(phoneNumber.number);
              this.isValidNumber.emit(true);
            }
            else {
              this.invalidNumber = true;
              this.isValidNumber.emit(false);
            }
        }
    }
    else {
      this.invalidNumber = true;
      this.isValidNumber.emit(false);
    }
  }
}